export const QUESTION_IDS = {
  WELCOME: 'welcome',
  CONCLUSION: 'conclusion',
  SEND_RESOURCES: 'send_resources',
  END: 'end',
  CHAT_REASON: 'chat_reason',
};

export const NAVIGATION_ACTIONS = {
  NAVIGATE_TO_CHAT_AGENT: 'NAVIGATE_TO_CHAT_AGENT',
  NAVIGATE_TO_APPOINTMENT_RESERVE: 'NAVIGATE_TO_APPOINTMENT_RESERVE',
};

export const MESSAGE_ID_PREFIXES = {
  SYSTEM: 'system',
  USER: 'user',
};

export const TEXT_SEPARATORS = {
  DOUBLE_LINE_BREAK: '\n\n',
};

export const TIMEOUTS = {
  MESSAGE_DELAY: 500,
};

export const ARRAY_LENGTHS = {
  SINGLE_ITEM: 1,
};

export const OPTION_VALUES = {
  NONE: 'none',
};

export const CSS_CLASSES = {
  BUTTON_VARIANT_TERCIARY: 'terciary',
  BUTTON_FULL_WIDTH: 'w-full justify-start text-left',
  INPUT_FULL_WIDTH: 'w-full',
  BUTTON_CONTINUE: 'mt-2 w-full',
  BUTTON_SUBMIT: 'mt-4 w-full',
  SPACE_Y_2: 'mt-4 space-y-2',
  TEXT_INPUT_CONTAINER: 'mt-4',
  CHECKBOX_CONTAINER: 'flex items-center space-x-2',
  CHECKBOX_LABEL: 'text-sm',
} as const;
